export class ReportEmailConfiguration {
    shouldSendToAssessmentTaker = false;
    shouldSendToMyself = false;
    othersEmailList: string[] = [];
    subject: string;
    message: string;
    contributorsList: string[] = [];
}
export class JobReportEmailConfiguration {
    shouldSendToMyself = false;
    othersEmailList: string[] = [];
    subject: string;
    message: string;
    contributorsList: string[] = [];
}
